import React, { JSX } from 'react';
import { StyledButton } from './style';
import ButtonCorners from './ButtonCorners';
import { ComposeType, StyledDiv } from '../../../Theme/CommonStyled';
import Lottie from 'lottie-react';
import LoadingSpinner from '../../../Assets/images/spinner-loading.json';

type LoginButtonType = ComposeType & {
  disabled?: boolean;
  onClick?: () => void;
  children: JSX.Element | string;
  errorStatus?: boolean;
  loading?: boolean;
};
const LoginButton: React.FC<LoginButtonType> = ({
  disabled,
  onClick,
  children,
  errorStatus,
  loading,
  ...rest
}) => {
  return (
    <StyledButton
      type="submit"
      errorStatus={errorStatus}
      disabled={disabled}
      onClick={onClick}
      loading={loading}
      {...rest}>
      {(disabled || loading) && !errorStatus && <ButtonCorners />}
      {children}

      {loading && (
        <StyledDiv width={'48px'} height={'48px'} position="absolute" right={9}>
          <Lottie animationData={LoadingSpinner} loop={true} />
        </StyledDiv>
      )}
    </StyledButton>
  );
};

export default LoginButton;
